import { ref } from 'vue'

const STORAGE_KEY = 'sj-fictional-data-disclaimer-v1'

const acknowledged = ref(false)
const modalOpen = ref(false)
let initialized = false

function readStorage() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function ensureInit() {
  if (initialized) return
  initialized = true
  acknowledged.value = readStorage()
}

export function useFictionalDataDisclaimer() {
  ensureInit()

  function acknowledge() {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      /* ignore quota / private mode */
    }
    acknowledged.value = true
  }

  function openModal() {
    modalOpen.value = true
  }

  function checkAndOpenForCompetition() {
    ensureInit()
    if (!acknowledged.value) {
      modalOpen.value = true
    }
  }

  return {
    acknowledged,
    modalOpen,
    acknowledge,
    openModal,
    checkAndOpenForCompetition,
  }
}
